import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["strict", "step", "min", "max", "value", "onValueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file number
 */
import React from 'react';
import { RegionProvider, useSimpleRegion } from '@tencent/glue-react-region';
import { InputNumberContent } from './InputNumberContent';
export function InputNumber(props) {
  var strict = props.strict,
      step = props.step,
      min = props.min,
      max = props.max,
      value = props.value,
      onValueChange = props.onValueChange,
      extra = _objectWithoutProperties(props, _excluded);

  var _useSimpleRegion = useSimpleRegion({
    value: value === undefined ? 0 : value,
    strict: strict,
    step: step,
    min: min,
    max: max
  }, onValueChange),
      _useSimpleRegion2 = _slicedToArray(_useSimpleRegion, 1),
      region = _useSimpleRegion2[0];

  return React.createElement(RegionProvider, {
    value: region
  }, React.createElement(InputNumberContent, _objectSpread({}, extra)));
}